module.exports = __webpack_public_path__ + "assets/img/Nexon-2-Landing-Page.bfdf8d14.jpg";